import { z } from 'zod';
import { EmailSchema } from './common.js';

/**
 * Request body para invitar un admin a un condominio.
 * Email es requerido; displayName es opcional.
 */
export const InviteAdminRequestSchema = z.object({
  email: EmailSchema,
  displayName: z.string().trim().min(1).max(100).optional(),
});
export type InviteAdminRequest = z.infer<typeof InviteAdminRequestSchema>;

/**
 * Membership de un admin en el sistema platform.
 * Modelo de stored en DynamoDB AdminMembership entity.
 */
export const AdminMembershipSchema = z.object({
  cognitoSub: z.string(),
  email: EmailSchema,
  displayName: z.string().optional(),
  status: z.enum(['active', 'suspended']),
  grantedAt: z.iso.datetime({ offset: true }),
  grantedByUserId: z.string().nullable(),
});
export type AdminMembership = z.infer<typeof AdminMembershipSchema>;

/**
 * Response para listar memberships.
 */
export const AdminMembershipListSchema = z.object({
  items: z.array(AdminMembershipSchema),
});
export type AdminMembershipList = z.infer<typeof AdminMembershipListSchema>;

/**
 * Rol union exclusivamente para memberships
 * (no incluye super_admin que es rol de plataforma).
 */
export const MembershipRolSchema = z.enum([
  'admin',
  'comite',
  'conserje',
  'propietario',
  'residente',
]);
export type MembershipRol = z.infer<typeof MembershipRolSchema>;
